import { insertURLQuery } from '@libs/shared';
import { getStaticSiteRouter, STATIC_SITE_ROUTER_TYPE } from '~/utils/site';
import { SITE_ROUTER } from '~/constants';

/**
 * 生成代管企业邀请成员确认链接。
 *
 * @param hostId 发起邀请的主体企业 Id
 * @param guestId 被邀请的客体企业 Id
 */
export const getGuestMemberInviteConfirm = (hostId: string, guestId: string) => {
    return insertURLQuery(
        getStaticSiteRouter(STATIC_SITE_ROUTER_TYPE.SITE, SITE_ROUTER.CORP_JOIN),
        [
            {
                key: 'host_corp_id',
                value: hostId
            },
            {
                key: 'corp_id',
                value: guestId
            }
        ]
    );
};
